import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emptyTextReplace' })
export class EmptyTextReplacePipe implements PipeTransform {

    transform(value: string): string {
        if(!value){
            return '-';
        }

       return value;
    }
}